/*
 * @Author: vince
 * @Date: 2022-11-27 16:21:13
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-06-30 17:28:49
 * @Description:
 */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' //el样式
// import 'element-ui/lib/theme-chalk/display.css'//响应式样式,隐藏
import router from './router'   //组件样式 覆盖前面el样式
import store from './store/store.js'
// 版本必须echarts@4.9.0
import Echarts from 'echarts'
import { getTime } from './utils/proto.js'
import './utils/http'
// import './utils/rem'
import './filters/index.js'
// 导入重置样式的base.less
import './styles/base.less'
import './styles/elbase.less'
import './styles/icon.css'

// 只要是基于vue的插件, 一律需要先Vue.use一下才能用
Vue.use(ElementUI)

//序列化
import qs from 'qs';
Vue.prototype.$qs = qs
Vue.prototype.$echarts = Echarts
// Vue.use(Echarts)
Vue.config.productionTip = false


getTime(curTime => {


  //设置默认学年学期
  Vue.prototype.curTermPro = curTime.schoolTerm.toString();
  Vue.prototype.curYearPro = curTime.schoolYear.toString();
});

console.log("process.env.NODE_ENV", process.env.NODE_ENV);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
